import { render, staticRenderFns } from "./BeenCreatedTable.vue?vue&type=template&id=5711cb3e&scoped=true"
import script from "./BeenCreatedTable.vue?vue&type=script&lang=js"
export * from "./BeenCreatedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711cb3e",
  null
  
)

export default component.exports